import { ZipFileIcon, Mp4FileIcon, ImageFileIcon, UnknownFileIcon } from 'assets';

export function getFileIconByType(type: string): JSX.Element {
  const normalized = type.toLowerCase();

  if (
    normalized === 'application/x-zip-compressed' ||
    normalized === 'application/zip' ||
    normalized.endsWith('.zip')
  ) {
    return <ZipFileIcon />;
  }

  if (normalized === 'video/mp4' || normalized.endsWith('.mp4') || normalized.endsWith('.mov')) {
    return <Mp4FileIcon />;
  }

  if (
    normalized === 'image/jpeg' ||
    normalized === 'image/svg+xml' ||
    normalized === 'image/png' ||
    normalized.startsWith('image/') ||
    normalized.endsWith('.jpg') ||
    normalized.endsWith('.jpeg') ||
    normalized.endsWith('.png') ||
    normalized.endsWith('.svg') ||
    normalized.endsWith('.gif') ||
    normalized.endsWith('.webp')
  ) {
    return <ImageFileIcon />;
  }

  return <UnknownFileIcon />;
}
